module.exports = __webpack_public_path__ + "static/IS1-ffebd299d9153b0f6c516754a15cf605.jpg";